import Intro from "./Intro"
import About from "./About"
import Projects from "./Projects/Projects";
import Skills from "./Skills";

import "./MainView.css"

function MainView() {
  return (
    <div className="MainView">
      <Intro />
      <About />
      <Skills />
      <Projects />
      <div id="bottom" className="footer" style={{
        backgroundImage:
          "url('/images/boxLogos.jpg')"
        }}
      >
        <div className="footer-internal" />
      </div>
    </div>
  );
}

export default MainView;
